module.exports = __webpack_public_path__ + "img/logo_aliyun@2x.d2a8e001.png";